import { render, staticRenderFns } from "./blog-overview.vue?vue&type=template&id=0cc2979f&scoped=true&lang=pug"
import script from "./blog-overview.vue?vue&type=script&lang=ts"
export * from "./blog-overview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc2979f",
  null
  
)

export default component.exports